import { connect } from 'react-redux';

import GallerySwiper from 'src/components/GallerySwiper';

import { getIsMobile } from 'src/store/view/selectors';
import { getHotelName, getHotelId } from 'src/routes/Hotel/store/hotel';
import { getHotelImages } from '../../store/selectors/images';
import { hotelVideoSelector } from '../../store/selectors/video';

const mapStateToProps = (state) => ({
  images: getHotelImages(state),
  video: hotelVideoSelector(state),
  hotelId: getHotelId(state),
  title: getHotelName(state),
  isMobile: getIsMobile(state),
});

const connector = connect(mapStateToProps);
export type PropsFromRedux = ReturnType<typeof mapStateToProps>;
export default connector(GallerySwiper);
